<template>
  <div>
    <div class="auth-page">
      <b-container>
        <Billboard />
        <br />
        <div class="widget-auth mx-auto">
          <router-view />
        </div>
        <b-row class="text-center">
          <b-col md="12">
            {{ $t("contactInformation") }}:
            <div v-if="$isLoadingPartner">
              <b-spinner label="Spinning"></b-spinner>
            </div>
            <div v-else-if="$partner">
              <a :href="'mailto:' + $partner.email">{{ $partner.email }}</a>
            </div>
            <div v-else>
              <a href="mailto: support@prewoe.com">support@prewoe.com</a>
              <br />
              <span class="text-muted">{{ currentYear }} &copy; PreWoe AB</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Billboard from "@/components/Billboard/BillboardLogin";
import { mapActions, mapGetters } from "vuex";
import CompanyService from "@/services/CompanyService";

export default {
  name: "LoginView",
  components: {
    Billboard
  },
  data() {
    return {
      partnerRef: null
    };
  },
  mounted() {
    var hostname = document.location.hostname;

    if (hostname == "www.app.keeada.eu" || hostname == "app.keeada.eu") {
      this.partnerRef = "keeada";
    } else if (hostname == "www.app.isocertifiering.nu" || hostname == "app.isocertifiering.nu") {
      this.partnerRef = "isocertifiering";
    } else if (hostname == "www.app.qbic.se" || hostname == "app.qbic.se") {
      this.partnerRef = "qbic";
    }

    this.getPartnerCompany();
  },
  methods: {
    ...mapActions("layout", {
      $setPartner: "setPartner",
      $setIsLoadingPartner: "setIsLoadingPartner"
    }),
    getPartnerCompany() {
      if (this.partnerRef && !this.$partner) {
        this.$setIsLoadingPartner(true);
        CompanyService.getPartnerByPartnerRef(this.partnerRef)
          .then((company) => {
            this.$setPartner(company);
          })
          .finally(() => {
            this.$setIsLoadingPartner(false);
          });
      }
    }
  },
  computed: {
    ...mapGetters("layout", {
      $isLoadingPartner: "isLoadingPartner",
      $partner: "partner"
    }),
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style src="./LoginView.scss" lang="scss" />
